import compactAdd from './compact-add.svg';
import compactAngledPin from './compact-angled-pin.svg';
import compactArrowUpRight from './compact-arrow-up-right.svg';
import compactCancel from './compact-cancel.svg';
import compactCheck from './compact-check.svg';
import compactCheckCircleFill from './compact-check-circle-fill.svg';
import compactChevronDown from './compact-chevron-down.svg';
import compactChevronLeft from './compact-chevron-left.svg';
import compactChevronRight from './compact-chevron-right.svg';
import compactChevronUp from './compact-chevron-up.svg';
import compactDash from './compact-dash.svg';
import compactEllipsis from './compact-ellipsis.svg';
import compactInfoCircleFill from './compact-info-circle-fill.svg';
import compactLock from './compact-lock.svg';
import compactMaximize from './compact-maximize.svg';
import compactMute from './compact-mute.svg';
import compactSound from './compact-sound.svg';
import compactSoundSlash from './compact-sound-slash.svg';
import compactSparkle from './compact-sparkle.svg';
import compactWorkflowStatusCanceled from './compact-workflow-status-canceled.svg';
import compactWorkflowStatusHalted from './compact-workflow-status-halted.svg';
import compactWorkflowStatusInProgress from './compact-workflow-status-in-progress.svg';
import compactWorkflowStatusProblem from './compact-workflow-status-problem.svg';
import compactWorkflowStatusUnstarted from './compact-workflow-status-unstarted.svg';
import compactWorkflowStatusWarning from './compact-workflow-status-warning.svg';

const icons = Object.freeze({
  'compact-add': compactAdd,
  'compact-angled-pin': compactAngledPin,
  'compact-arrow-up-right': compactArrowUpRight,
  'compact-cancel': compactCancel,
  'compact-check': compactCheck,
  'compact-check-circle-fill': compactCheckCircleFill,
  'compact-chevron-down': compactChevronDown,
  'compact-chevron-left': compactChevronLeft,
  'compact-chevron-right': compactChevronRight,
  'compact-chevron-up': compactChevronUp,
  'compact-dash': compactDash,
  'compact-ellipsis': compactEllipsis,
  'compact-info-circle-fill': compactInfoCircleFill,
  'compact-lock': compactLock,
  'compact-maximize': compactMaximize,
  'compact-mute': compactMute,
  'compact-sound': compactSound,
  'compact-sound-slash': compactSoundSlash,
  'compact-sparkle': compactSparkle,
  'compact-workflow-status-canceled': compactWorkflowStatusCanceled,
  'compact-workflow-status-halted': compactWorkflowStatusHalted,
  'compact-workflow-status-in-progress': compactWorkflowStatusInProgress,
  'compact-workflow-status-problem': compactWorkflowStatusProblem,
  'compact-workflow-status-unstarted': compactWorkflowStatusUnstarted,
  'compact-workflow-status-warning': compactWorkflowStatusWarning,
});

export default icons;
